import React, { Component } from 'react';
import { UploadPanel } from "../components";
import { constant } from "../helpers";
import './Site.css';
import {Redirect} from "react-router-dom";

export default class ProductUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToProducts: false
    }
  }
  
  render() {
    if (this.state.redirectToProducts){
      return (<Redirect to="/admin" />);
    }
    
    return (
      <div>
          <UploadPanel
            uploadType={constant.uploadType.product}
            onSuccess={() => this.setState({redirectToProducts: true})}
          />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductUpload.js